// extracted by mini-css-extract-plugin
export default {"btnGoogle":"Makers_btnGoogle__bOZEF"};